import { type TableParamsType } from '../../types/common';
import { type UseQueryResult, useQuery } from 'react-query';

import {
  ReleaseAppSharedService,
  ReleaseService,
  // eslint-disable-next-line camelcase
  PagedResultDto_GetReleaseDto,
} from '../../services/wealthlane-award-services';

const useGetTransactionsReleaseList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType,
  filter: TableParamsType
): UseQueryResult<
  // eslint-disable-next-line camelcase
  | PagedResultDto_GetReleaseDto
  | undefined,
  unknown
> => {
  const {
    filter: searchKeyWord,
    sorting,
    skipCount,
    maxResultCount,
    name,
    releaseDate: expectedRelseaseDate,
    statusId: releaseStatusId,
    _force,
  } = tableInfo;
  // const {releaseDate:expectedRelseaseDate,statusId:releaseStatusId}= filter;
  const transactionsReleaseList = useQuery(
    [
      'getTransactionsReleaseList',
      searchKeyWord,
      sorting,
      skipCount,
      maxResultCount,
      expectedRelseaseDate,
      releaseStatusId,
      _force,
    ],
    async () => {
      return await handleRequest(
        ReleaseAppSharedService.getApiAwardApiAppReleaseReleaseList(
          sorting,
          skipCount,
          maxResultCount,
          searchKeyWord,
          name,
          expectedRelseaseDate,
          releaseStatusId
        )
      );
    },
    {
      select: (data) => {
        if (data != null) {
          return data;
        }
      },
    }
  );

  return transactionsReleaseList;
};

export default useGetTransactionsReleaseList;
